import React from "react";
import AppConfig from "../common/AppConfig";
import useToken from "../useToken";
import Login from "../Login";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Register from "../Register";
import Home from "../Home";
import TTCheck from "../steps/TTCheck";
import TfCheckSocket from "../steps/TfCheckSocket";
import TtDefinitive from "../steps/TtDefinitive";
import TFDefinitive from "../steps/TFDefinitive";
import TTOneSocket from "../steps/TTOneSocket";
import TFStandardRevo from "../steps/TFStandardRevo";
import TTStandardRevo from "../steps/TTStandardRevo";
import PatientReview from "../steps/PatientReview";
import TFOneSocket from "../steps/TFOneSocket";
import Bilateral from "../steps/Bilateral";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/NotFound";
import OneSocketPatientReview from "../steps/OneSocketPatientReview";
import DefinitiveReview from "../steps/DefinitiveReview";
import InternalReview from "../steps/InternalReview";
import TTXtremitySocket from "../steps/TTXtremitySocket";
import XtremityReview from "../steps/XtremityReview";
import KneeBundle from "../steps/KneeBundle";
import KneeBundleReview from "../steps/KneeBundleReview";
import LinerBundle from "../steps/LinerBundle";
import DesignerLinerBundle from "../steps/DesignerLinerBundle";
import SimpleCartReview from "../steps/SimpleCartReview";
import FootBundle from "../steps/FootBundle";
import DesignLinerReview from "../steps/DesignLinerReview";
import DesignLinerReviewBilateral from "../steps/DesignLinerReviewBilateral";
import InternalReviewDefinitive from "../steps/InternalReviewDefinitive";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Routing = () => {
  const { setToken } = useToken();

  const url = useLocation();
  const currentLocation = url.pathname;
  const split = currentLocation.split("-");
  
  let query = useQuery();

  return (
    <>
      {/* {!isRegisterPage && !isLoginPage && !isNotFoundPage && <Header />} */}
      <Routes>
        {split.length > 1 && (
          <Route
            path={currentLocation}
            x
            element={
              <ProtectedRoute>
                <Bilateral url={split[0]} split={split[1]} formId={split[1]} />
              </ProtectedRoute>
            }
          />
        )}

        <Route
          path={`${AppConfig.orderFormPath}/login`}
          element={<Login setToken={setToken} />}
        />
        <Route
          path={`${AppConfig.orderFormPath}/register`}
          element={<Register />}
        />
        <Route
          path={`${AppConfig.orderFormPath}/`}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/ttchecksocket`}
          element={
            <ProtectedRoute>
              <TTCheck />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/liners`}
          element={
            <ProtectedRoute>
              <LinerBundle />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/feet`}
          element={
            <ProtectedRoute>
              <FootBundle />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/designliners`}
          element={
            <ProtectedRoute>
              <DesignerLinerBundle />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/internalsummary`}
          element={
            ( (query.get("f") === "3" || query.get("f") === "4") ? //TF or TT Check Sockets
              <InternalReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Check Socket Summary"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "5" || query.get("f") === "6") ? //TF or TT Definitive Sockets
              <InternalReviewDefinitive
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Definitive Socket Summary"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : <NotFound /> //Other
            )
          }
        />

        <Route
          path={`${AppConfig.orderFormPath}/summary`}
          element={
            ( (query.get("f") === "3" || query.get("f") === "4") ? //TF or TT Check Sockets
              <PatientReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Check Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "5" || query.get("f") === "6") ? //TF or TT Definitive Sockets
              <DefinitiveReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="Definitive Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "7" || query.get("f") === "8") ? //TF or TT One Sockets
              <OneSocketPatientReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                formName="One® Socket Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
              />
            : (query.get("f") === "11") ? //Xtremity TT
            <XtremityReview
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Xtremity Socket Review"
              handleNext={()=>{return}}
              handleBack={()=>{return}}
              handleError={(e)=>{console.log(e)}}
            />
            : (query.get("f") === "13") ? //Knee Bundle
            <KneeBundleReview
              formTypeId={query.get("f")}
              uniqueId={query.get("u")}
              formName="Knee Bundle Review"
              handleNext={()=>{return}}
              handleBack={()=>{return}}
              handleError={(e)=>{console.log(e)}}
            />
            : (query.get("f") === "14") ? //Liner Bundle
              <>
                {query.get("m") !== null && query.get("m").toLowerCase() === "true" ?
                  <SimpleCartReview
                    formTypeId={query.get("f")}
                    uniqueId={query.get("u")}
                    formName="Liner Order Review"
                    handleNext={() => { return }}
                    handleBack={() => { return }}
                    handleError={(e) => { console.log(e) }}
                    isMulti={true}
                  /> : <SimpleCartReview
                    formTypeId={query.get("f")}
                    uniqueId={query.get("u")}
                    formName="Liner Order Review"
                    handleNext={() => { return }}
                    handleBack={() => { return }}
                    handleError={(e) => { console.log(e) }}
                  />}
              </>
              : (query.get("f") === "15") ? //Foot Bundle
                <SimpleCartReview
                  formTypeId={query.get("f")}
                  uniqueId={query.get("u")}
                  formName="Foot Order Review"
                  handleNext={() => { return }}
                  handleBack={() => { return }}
                  handleError={(e) => { console.log(e) }}
                />
            : (query.get("f") === "23") ? //Design Liner Bundle
            <>
              {query.get("b") !== null && query.get("b").toLowerCase() === "true" ?
                <DesignLinerReviewBilateral
                  formTypeId={query.get("f")}
                  uniqueId={query.get("u")}
                  isBilateral={true}
                  formName="Design Liner Review"
                  handleNext={() => { return }}
                  handleBack={() => { return }}
                  handleError={(e) => { console.log(e) }}
                  formIndex={[0,1]}
                  orderNumber={1}
                /> : 
                <DesignLinerReview
                formTypeId={query.get("f")}
                uniqueId={query.get("u")}
                isBilateral={false}
                formName="Design Liner Review"
                handleNext={()=>{return}}
                handleBack={()=>{return}}
                handleError={(e)=>{console.log(e)}}
                formIndex={null}
                orderNumber={1}
              />}
            </>
            : <NotFound /> //Other
            )
          }
        />

        <Route
          path={`${AppConfig.orderFormPath}/tfchecksocket`}
          element={
            <ProtectedRoute>
              <TfCheckSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/ttdefinitive`}
          element={
            <ProtectedRoute>
              <TtDefinitive />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/tfdefinitive`}
          element={
            <ProtectedRoute>
              <TFDefinitive />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/tfstandardrevo`}
          element={
            <ProtectedRoute>
              <TFStandardRevo />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/ttstandardrevo`}
          element={
            <ProtectedRoute>
              <TTStandardRevo />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/ttonesocket`}
          element={
            <ProtectedRoute>
              <TTOneSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/tfonesocket`}
          element={
            <ProtectedRoute>
              <TFOneSocket />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/ttxtremity`}
          element={
            <ProtectedRoute>
              <TTXtremitySocket />
            </ProtectedRoute>
          }
        />

        <Route path={`${AppConfig.orderFormPath}/kneebundle`}
          element={
            <ProtectedRoute>
              <KneeBundle />
            </ProtectedRoute>
          }
        />

        <Route
          path={`*`}
          element={
            <ProtectedRoute>
              <Navigate to={`${AppConfig.orderFormPath}/`} />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${AppConfig.orderFormPath}/*`}
          element={
            <ProtectedRoute isNotFound={true}>
              <NotFound />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <PageController formTypeId={parseInt(formTypeId)} uniqueId={uniqueId} /> */}
    </>
  );
};

export default Routing;
